import { HelpersService } from 'src/app/services/helpers.service';
import { MentoriaService } from './../../../services/mentoria.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-questao',
  templateUrl: './questao.component.html',
  styleUrls: ['./questao.component.css']
})
export class QuestaoComponent implements OnInit {

  hackathonId = this.helper.hackathonId;
  questoes = [];
  showSpinner = false;

  constructor(public mentoria: MentoriaService,
              private helper: HelpersService,
              public auth: AuthService) { }

  // ajustar para os mentores poderem acessar os chats
  // verificar como criar notificacoes

  ngOnInit() {
    // Captura o parametro recebido do outro component
    // this.forumID = this.route.snapshot.paramMap.get('forumID');

    const questoesList = this.mentoria.getQuestoesList(this.hackathonId);
    questoesList.then(list => {
      list.docs.forEach(e => {
        let document: any = e.data();
        document.id = e.id;
        this.questoes.push(document);
      });
      this.showSpinner = false;
    });
  }

  ngAfterContentInit() {
    this.showSpinner = false;
  }

}
